<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

@if (versionResult$ | async; as versionResult) {
  <cas-directory-edit
    [directory]="directory$ | async"
    [terraformVersions]="versionResult"
    [maxParallelism]="maxParallelism$ | async"
    (updateDirectory)="onUpdateDirectory($event)"
  ></cas-directory-edit>
}
